import { useCallback } from "react";

import { queryOptions, useQuery, useQueryClient } from "@tanstack/react-query";

import { CompletedTask } from "shared/config/consts/tasks";

import { cloudStorageKeys } from "../types";
import { getCloudStorage } from "../utils/get-cloud-storage";

export const getCompletedTasksQueryOptions = () => {
  return queryOptions({
    queryKey: ["tasks"],
    queryFn: async () => {
      const cloudStorage = getCloudStorage();

      const tasksStr = await cloudStorage.getItem(cloudStorageKeys.tasks);
      const tasks: CompletedTask[] = tasksStr ? JSON.parse(tasksStr) : [];

      return tasks;
    },

    staleTime: Infinity,
  });
};

export const useCompletedTasksQuery = () => {
  return useQuery(getCompletedTasksQueryOptions());
};

export const useFetchCompletedTasks = () => {
  const queryClient = useQueryClient();
  return useCallback(() => {
    return queryClient.fetchQuery(getCompletedTasksQueryOptions());
  }, [queryClient]);
};
